import { client } from '../client';
import { Language } from './types/UserProfile';

export const listAllLanguages = async (): Promise<Language[]> => {
  const { data } = await client.get('/languages');

  return data;
};
